/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.00012 7V9C9.00012 10.6569 10.3433 12 12.0001 12V12C13.657 12 15.0001 10.6569 15.0001 9V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.29296 9.83093C3.53933 7.51216 3.66252 6.35278 4.09867 5.43185C4.7857 3.98121 6.02531 2.86632 7.54042 2.33641C8.50228 2 9.66819 2 12 2V2C14.3318 2 15.4977 2 16.4596 2.33641C17.9747 2.86632 19.2143 3.98121 19.9013 5.43185C20.3375 6.35278 20.4607 7.51216 20.707 9.83092L20.9434 12.056C21.2676 15.107 21.4297 16.6324 21.0382 17.8443C20.5141 19.467 19.3242 20.79 17.7659 21.4827C16.6022 22 15.0682 22 12 22V22C8.93184 22 7.39777 22 6.23406 21.4827C4.67581 20.79 3.48593 19.467 2.96176 17.8443C2.5703 16.6324 2.73239 15.107 3.05655 12.056L3.29296 9.83093Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M3.29296 9.83093C3.53933 7.51216 3.66252 6.35278 4.09867 5.43185C4.7857 3.98121 6.02531 2.86632 7.54042 2.33641C8.50228 2 9.66819 2 12 2C14.3318 2 15.4977 2 16.4596 2.33641C17.9747 2.86632 19.2143 3.98121 19.9013 5.43185C20.3375 6.35278 20.4607 7.51216 20.707 9.83092L20.9434 12.056C21.2676 15.107 21.4297 16.6324 21.0382 17.8443C20.5141 19.467 19.3242 20.79 17.7659 21.4827C16.6022 22 15.0682 22 12 22C8.93184 22 7.39777 22 6.23406 21.4827C4.67581 20.79 3.48593 19.467 2.96176 17.8443C2.5703 16.6324 2.73239 15.107 3.05655 12.056L3.29296 9.83093Z"
				fill="currentColor"
			/>
			<path
				d="M9.00012 7V9C9.00012 10.6569 10.3433 12 12.0001 12V12C13.657 12 15.0001 10.6569 15.0001 9V7M12 22V22C15.0682 22 16.6022 22 17.7659 21.4827C19.3242 20.79 20.5141 19.467 21.0382 17.8443C21.4297 16.6324 21.2676 15.107 20.9434 12.056L20.707 9.83092C20.4607 7.51216 20.3375 6.35278 19.9013 5.43185C19.2143 3.98121 17.9747 2.86632 16.4596 2.33641C15.4977 2 14.3318 2 12 2V2C9.66819 2 8.50228 2 7.54042 2.33641C6.02531 2.86632 4.7857 3.98121 4.09867 5.43185C3.66252 6.35278 3.53933 7.51216 3.29296 9.83093L3.05655 12.056C2.73239 15.107 2.5703 16.6324 2.96176 17.8443C3.48593 19.467 4.67581 20.79 6.23406 21.4827C7.39777 22 8.93184 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.93142 1.4893C8.82297 1.25 9.88196 1.25 11.9999 1.25C14.1179 1.25 15.1769 1.25 16.0685 1.4893C18.2279 2.0689 19.9805 3.64515 20.785 5.73121C21.1171 6.59248 21.229 7.64555 21.4528 9.75168L21.6892 11.9767C21.9858 14.7686 22.1341 16.1645 21.8778 17.2964C21.3406 19.6679 19.6112 21.5908 17.3097 22.3755C16.2113 22.75 14.8075 22.75 11.9999 22.75C9.19241 22.75 7.78863 22.75 6.69017 22.3755C4.38867 21.5908 2.65929 19.6679 2.12213 17.2964C1.86575 16.1645 2.01407 14.7686 2.3107 11.9767L2.54711 9.75168C2.77089 7.64555 2.88277 6.59248 3.21493 5.73121C4.01944 3.64515 5.77204 2.0689 7.93142 1.4893ZM9.75012 9.00003C9.75012 10.2427 10.7575 11.25 12.0001 11.25C13.2428 11.25 14.2501 10.2427 14.2501 9.00003V7.00003C14.2501 6.58581 14.5859 6.25003 15.0001 6.25003C15.4143 6.25003 15.7501 6.58581 15.7501 7.00003V9.00003C15.7501 11.0711 14.0712 12.75 12.0001 12.75C9.92906 12.75 8.25012 11.0711 8.25012 9.00003V7.00003C8.25012 6.58581 8.58591 6.25003 9.00012 6.25003C9.41434 6.25003 9.75012 6.58581 9.75012 7.00003V9.00003Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20.725 10L20.6719 9.5V9.5C20.4587 7.49394 20.3522 6.49091 20.0118 5.67933C19.3179 4.025 17.9202 2.76793 16.2018 2.25274C15.3588 2 14.3501 2 12.3328 2H12C9.66819 2 8.50228 2 7.54042 2.33641C6.02531 2.86632 4.7857 3.98121 4.09867 5.43185C3.66252 6.35278 3.53933 7.51216 3.29296 9.83093L3.05655 12.056C2.73239 15.107 2.5703 16.6324 2.96176 17.8443C3.48593 19.467 4.67581 20.79 6.23406 21.4827C7.39777 22 8.93184 22 12 22H14.4578C15.2575 22 15.6574 22 15.9841 21.9641C19.0177 21.6308 21.3177 19.0734 21.3287 16.0216C21.3299 15.6929 21.2876 15.2953 21.2031 14.5V14.5L21.15 14M9 7V9C9 10.6569 10.3431 12 12 12V12C13.6569 12 15 10.6569 15 9V7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9.00012 7V9C9.00012 10.6569 10.3433 12 12.0001 12V12C13.657 12 15.0001 10.6569 15.0001 9V7M12 22V22C15.0682 22 16.6022 22 17.7659 21.4827C19.3242 20.79 20.5141 19.467 21.0382 17.8443C21.4297 16.6324 21.2676 15.107 20.9434 12.056L20.707 9.83092C20.4607 7.51216 20.3375 6.35278 19.9013 5.43185C19.2143 3.98121 17.9747 2.86632 16.4596 2.33641C15.4977 2 14.3318 2 12 2V2C9.66819 2 8.50228 2 7.54042 2.33641C6.02531 2.86632 4.7857 3.98121 4.09867 5.43185C3.66252 6.35278 3.53933 7.51216 3.29296 9.83093L3.05655 12.056C2.73239 15.107 2.5703 16.6324 2.96176 17.8443C3.48593 19.467 4.67581 20.79 6.23406 21.4827C7.39777 22 8.93184 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M11.9999 1.25C9.88194 1.25 8.82294 1.25 7.9314 1.4893C5.77202 2.0689 4.01941 3.64515 3.21491 5.73121C2.88275 6.59248 2.77086 7.64555 2.54709 9.75168L2.31068 11.9767C2.01404 14.7686 1.86573 16.1645 2.1221 17.2964C2.65926 19.6679 4.38865 21.5908 6.69015 22.3755C7.78861 22.75 9.19238 22.75 11.9999 22.75C14.8075 22.75 16.2112 22.75 17.3097 22.3755C19.6112 21.5908 21.3406 19.6679 21.8777 17.2964C22.1341 16.1645 21.9858 14.7686 21.6892 11.9767L21.4528 9.75168C21.229 7.64555 21.1171 6.59248 20.7849 5.73121C19.9804 3.64515 18.2278 2.0689 16.0684 1.4893C15.1769 1.25 14.1179 1.25 11.9999 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0001 11.25C10.7575 11.25 9.7501 10.2426 9.7501 9V7C9.7501 6.58579 9.41431 6.25 9.0001 6.25C8.58589 6.25 8.2501 6.58579 8.2501 7V9C8.2501 11.0711 9.92903 12.75 12.0001 12.75C14.0712 12.75 15.7501 11.0711 15.7501 9V7C15.7501 6.58579 15.4143 6.25 15.0001 6.25C14.5859 6.25 14.2501 6.58579 14.2501 7V9C14.2501 10.2426 13.2427 11.25 12.0001 11.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
